import { Route, Routes } from "react-router-dom";
import LoginPage from "../pages/auth/login";
import ProtectedRoute from "./protectedRoute.js";
import NotAuthorized from "../ui/sharedUi/notAuthorized.jsx";
import Categories from "../pages/Categories/index.jsx";
import AddCategoires from "../pages/Categories/addCategoires/index.jsx";
import Users from "../pages/users/index.jsx";
import UserDetails from "../pages/users/userDetails/index.jsx";
import Orders from "../pages/Orders/index.jsx";
import EditCategoires from "../pages/Categories/editCategoires/index.jsx";
import { Notifications } from "../pages/notifications/index.jsx";
import PaymentMethod from "../pages/paymentMethod/index.jsx";
import Roles from "../pages/roles/index.jsx";
import AddRoles from "../pages/roles/addRoles/index.jsx";
import EditRoles from "../pages/roles/editRoles/index.jsx";
import Permissions from "../pages/permissions/index.jsx";
import AddNotifications from "../pages/notifications/addNotifications/index.jsx";
import { OutComingNotifications } from "../pages/notifications/outComingNotifications/outComing.jsx";
import Home from "../pages/home/index.jsx";
import Employees from "../pages/employees/index.jsx";
import AddEmployees from "../pages/employees/addEmployees/index.jsx";
import EditEmployees from "../pages/employees/editEmployees/index.jsx";
import Reports from "../pages/reports/index.jsx";
import Prices from "../pages/Prices/index.jsx";
import EditPrices from "../pages/Prices/editPrices/index.jsx";
import AddPrices from "../pages/Prices/addPrices/index.jsx";
import Stores from "../pages/stores/index.jsx";
import AddStores from "../pages/stores/addStores/index.jsx";
import EditStores from "../pages/stores/editStores/index.jsx";
import DeliveryBoys from "../pages/deliveryBoys/index.jsx";
import AddDeliveryBoys from "../pages/deliveryBoys/addDeliveryBoys/index.jsx";
import EditDeliveryBoys from "../pages/deliveryBoys/editDeliveryBoys/index.jsx";
import Products from "../pages/products/index.jsx";
import AddProducts from "../pages/products/addProducts/index.jsx";
import EditProducts from "../pages/products/editProducts/index.jsx";
import Copons from "../pages/copon/index.jsx";
import AddCopons from "../pages/copon/addCopon/index.jsx";
import EditCopons from "../pages/copon/editCopon/index.jsx";
import DeliveryTransactionsPage from "../pages/deliveryBoys/transaction/index.jsx";

export default function ApplicationRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/not-authorized" element={<NotAuthorized />} />

            <Route path="/" element={
                <ProtectedRoute requiredPermission="stores.view">
                    <Home />
                </ProtectedRoute>}
            />
            <Route path="/categories" element={
                <ProtectedRoute requiredPermission="category.view">
                    <Categories />
                </ProtectedRoute>}
            />
            <Route path="/prices" element={
                <ProtectedRoute requiredPermission="price.view">
                    <Prices />
                </ProtectedRoute>}
            />
            <Route path="/stores" element={
                <ProtectedRoute requiredPermission="stores.view">
                    <Stores />
                </ProtectedRoute>}
            />
            <Route path="/products" element={
                <ProtectedRoute requiredPermission="product.view">
                    <Products />
                </ProtectedRoute>}
            />
            <Route path="/deliveryBoys" element={
                <ProtectedRoute requiredPermission="delivery.view">
                    <DeliveryBoys />
                </ProtectedRoute>}
            />
            <Route path="/deliveryBoys/edit/transactions/:id" element={
                <ProtectedRoute requiredPermission="delivery.view">
                    <DeliveryTransactionsPage />
                </ProtectedRoute>}
            />
            <Route path="/stores/add" element={
                <ProtectedRoute requiredPermission="stores.create">
                    <AddStores />
                </ProtectedRoute>}
            />
            <Route path="/products/add" element={
                <ProtectedRoute requiredPermission="product.create">
                    <AddProducts />
                </ProtectedRoute>}
            />
            <Route path="/deliveryBoys/add" element={
                <ProtectedRoute requiredPermission="delivery.create">
                    <AddDeliveryBoys />
                </ProtectedRoute>}
            />
            <Route path="/stores/edit/:storeId" element={
                <ProtectedRoute requiredPermission="stores.update">
                    <EditStores />
                </ProtectedRoute>}
            />
            <Route path="/products/edit/:productId" element={
                <ProtectedRoute requiredPermission="product.update">
                    <EditProducts />
                </ProtectedRoute>}
            />
            <Route path="/deliveryBoys/edit/:deliveryBoyId" element={
                <ProtectedRoute requiredPermission="delivery.update">
                    <EditDeliveryBoys />
                </ProtectedRoute>}
            />
            <Route path="/reports" element={
                <ProtectedRoute requiredPermission="stores.view">
                    <Reports />
                </ProtectedRoute>}
            />
            <Route path="/prices/edit/:priceId" element={
                <ProtectedRoute requiredPermission="price.update">
                    <EditPrices />
                </ProtectedRoute>}
            />
            <Route path="/prices/add" element={
                <ProtectedRoute requiredPermission="price.create">
                    <AddPrices />
                </ProtectedRoute>}
            />
            <Route path="/employees" element={
                <ProtectedRoute requiredPermission="employees.view">
                    <Employees />
                </ProtectedRoute>}
            />
            <Route path="/employees/add" element={
                <ProtectedRoute requiredPermission="employees.create">
                    <AddEmployees />
                </ProtectedRoute>}
            />
            <Route path="/roles" element={
                <ProtectedRoute requiredPermission="roles.view">
                    <Roles />
                </ProtectedRoute>}
            />
            <Route path="/roles/add" element={
                <ProtectedRoute requiredPermission="roles.create">
                    <AddRoles />
                </ProtectedRoute>}
            />
            <Route path="/notifications/add" element={
                <ProtectedRoute requiredPermission="stores.view">
                    <AddNotifications />
                </ProtectedRoute>}
            />
            <Route path="/notifications/outgoing" element={
                <ProtectedRoute requiredPermission="alert.view">
                    <OutComingNotifications />
                </ProtectedRoute>}
            />
            <Route path="/roles/edit/:roleId" element={
                <ProtectedRoute requiredPermission="roles.update">
                    <EditRoles />
                </ProtectedRoute>}
            />
            <Route path="/employees/edit/:employeeId" element={
                <ProtectedRoute requiredPermission="employees.update">
                    <EditEmployees />
                </ProtectedRoute>}
            />
            <Route path="/copons/edit/:coponId" element={
                <ProtectedRoute requiredPermission="employees.update">
                    <EditCopons />
                </ProtectedRoute>}
            />
            <Route path="/roles/edit/permissions/:permissionId" element={
                <ProtectedRoute requiredPermission="roles.update">
                    <Permissions />
                </ProtectedRoute>}
            />
            <Route path="/paymentMethod" element={
                <ProtectedRoute requiredPermission="stores.view">
                    <PaymentMethod />
                </ProtectedRoute>}
            />
            <Route path="/notifications" element={
                <ProtectedRoute requiredPermission="alert.view">
                    <Notifications />
                </ProtectedRoute>}
            />
            <Route path="/copons" element={
                <ProtectedRoute requiredPermission="alert.view">
                    <Copons />
                </ProtectedRoute>}
            />
            <Route path="/copons/add" element={
                <ProtectedRoute requiredPermission="alert.view">
                    <AddCopons />
                </ProtectedRoute>}
            />
            <Route path="/users" element={
                <ProtectedRoute requiredPermission="user.view">
                    <Users />
                </ProtectedRoute>}
            />
            <Route path="/orders" element={
                <ProtectedRoute requiredPermission='orders.view'>
                    <Orders />
                </ProtectedRoute>}
            />
            <Route path="/categories/add" element={
                <ProtectedRoute requiredPermission="category.create">
                    <AddCategoires />
                </ProtectedRoute>}
            />
            <Route path="/categories/edit/:categoryId" element={
                <ProtectedRoute requiredPermission="category.update">
                    <EditCategoires />
                </ProtectedRoute>}
            />
            <Route path="/users/details/:userId" element={
                <ProtectedRoute requiredPermission="user.view">
                    <UserDetails />
                </ProtectedRoute>}
            />
        </Routes>
    );
}